import React from 'react';
import { colors, Dropdown } from '@insurancemenu/imenu-components-lib';
import { ChevronDown, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';
import { DropdownOptionType, OptionsAlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { SubscribersFilter } from 'types/electionService';
import { DropdownOptionLabelStyled, FilterStatusStyled, FilterDropdownButtonStyled } from './styles';

export interface ElectionFilterProps {
  filter: SubscribersFilter;
  updateFilter: (filterName: SubscribersFilter) => void;
}

const convertFilterStatus = (filterStatus: SubscribersFilter): string => {
  if (filterStatus === SubscribersFilter.IN_CLASS) return 'Assigned class';
  if (filterStatus === SubscribersFilter.NOT_YET_IN_CLASS) return 'Unassigned class';
  if (filterStatus === SubscribersFilter.MISSING_INFORMATION) return 'Miss info';
  return filterStatus.split('_').join(' ');
};

const ElectionFilter = ({ filter, updateFilter }: ElectionFilterProps): JSX.Element => {
  const createFilterOption = (filterName: SubscribersFilter, filterTitle: string): DropdownOptionType => {
    return {
      value: filterName,
      label: <DropdownOptionLabelStyled>{filterTitle}</DropdownOptionLabelStyled>,
      onOptionClick: (): void => {
        updateFilter(filterName);
      },
    };
  };

  const filterOptions: DropdownOptionType[] = [
    createFilterOption(SubscribersFilter.ALL, 'All'),
    createFilterOption(SubscribersFilter.ELECTED, 'Elected'),
    createFilterOption(SubscribersFilter.NOT_YET_ELECTED, 'Not yet elected'),
    createFilterOption(SubscribersFilter.IN_CLASS, 'Assigned class'),
    createFilterOption(SubscribersFilter.NOT_YET_IN_CLASS, 'Unassigned class'),
    createFilterOption(SubscribersFilter.MISSING_INFORMATION, 'With missing information'),
  ];

  return (
    <Dropdown
      name="filter"
      options={filterOptions}
      optionsAlignment={OptionsAlignmentTypes.BOTTOM_RIGHT}
      optionsWidth="25.8rem"
      closedElement={
        <FilterDropdownButtonStyled
          size="large"
          color="custom"
          customColor={colors.neutral.white}
          rightIconProp={<ChevronDown />}
          $isSelected={false}
        >
          Filter <FilterStatusStyled>{convertFilterStatus(filter)}</FilterStatusStyled>
        </FilterDropdownButtonStyled>
      }
      openedElement={
        <FilterDropdownButtonStyled
          size="large"
          color="custom"
          customColor={colors.neutral.white}
          rightIconProp={<ChevronUp />}
          $isSelected
        >
          Filter <FilterStatusStyled>{convertFilterStatus(filter)}</FilterStatusStyled>
        </FilterDropdownButtonStyled>
      }
    />
  );
};

export default ElectionFilter;
